"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
var tslib_1 = require("tslib");
/**
 * Created by wangtong on 2021/1/4
 */
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var convert_1 = require("./convert");
require("dayjs/locale/zh-cn"); // 导入本地化语言
dayjs_1.default.locale('zh-cn'); // 使用本地化语言
var Time;
(function (Time) {
    Time.MilliSecond = 1;
    Time.Second = 1000 * Time.MilliSecond;
    Time.Minute = 60 * Time.Second;
    Time.Hour = 60 * Time.Minute;
    Time.Day = 24 * Time.Hour;
    Time.Month = 30 * Time.Day;
    Time.Year = 365 * Time.Day;
    Time.Template = {
        Full: 'YYYY-MM-DD dddd HH:mm:ss.SSS A',
        DateTime: 'YYYY-MM-DD HH:mm:ss',
        Time: 'HH:mm:ss',
        Date: 'YYYY-MM-DD',
        // 20150101010101
        Seq: 'YYYYMMDDHHmmss'
    };
    // 时间序列转换：20150101010101 --> '2015-01-01 01:01:01'
    function fromSeq(value) {
        var year = value.substr(0, 4);
        var month = value.substr(4, 2);
        var date = value.substr(6, 2);
        var hour = value.substr(8, 2);
        var minute = value.substr(10, 2);
        var second = value.substr(12, 2);
        var t = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second;
        return dayjs_1.default(t).toDate();
    }
    Time.fromSeq = fromSeq;
    function int(time) {
        if (!time) {
            return 0;
        }
        switch (typeof time) {
            case "number":
                return time;
            case "object":
                return time.getTime();
            default:
                return convert_1.Convert.parseInt(time);
        }
    }
    Time.int = int;
    function format(date, format) {
        return dayjs_1.default(date).format(format);
    }
    Time.format = format;
    function formatDate(date) {
        return Time.format(date, Time.Template.Date);
    }
    Time.formatDate = formatDate;
    function formatDateTime(date) {
        return Time.format(date, Time.Template.DateTime);
    }
    Time.formatDateTime = formatDateTime;
    function formatTime(date) {
        return Time.format(date, Time.Template.Time);
    }
    Time.formatTime = formatTime;
    function formatSeq(date) {
        return Time.format(date, Time.Template.Seq);
    }
    Time.formatSeq = formatSeq;
    function startOf() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            return dayjs_1.default(Date.now()).startOf(args[0]).toDate();
        }
        else {
            return dayjs_1.default(args[0]).startOf(args[1]).toDate();
        }
    }
    Time.startOf = startOf;
    function endOf() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            return dayjs_1.default(Date.now()).endOf(args[0]).toDate();
        }
        else {
            return dayjs_1.default(args[0]).endOf(args[1]).toDate();
        }
    }
    Time.endOf = endOf;
    function formatTimeRange() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var now = Date.now();
        var start = now;
        var end = now;
        switch (args.length) {
            case 1:
                var range = args[0];
                if (Array.isArray(range)) {
                    start = range[0] || now;
                    end = range[1] || now;
                }
                else if (typeof range === "number") {
                    start = range || now;
                }
                break;
            case 2:
                start = args[0] || now;
                end = args[1] || now;
                break;
        }
        return start + ',' + end;
    }
    Time.formatTimeRange = formatTimeRange;
})(Time || (Time = {}));
exports.Time = Time;
//# sourceMappingURL=time.js.map